import React from 'react';
import PropTypes from 'prop-types';

/**
 * UnreachableBadge - Displays an "UNREACHABLE" status badge
 * Styled to match the existing PAUSED badge in the deployment list
 */
const UnreachableBadge = ({ id }) => (
  <div
    id={id}
    style={{
      backgroundColor: '#f59e0b', // Amber/orange color matching wireframe
      color: 'white',
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: '10px',
      fontWeight: 'bold',
      textAlign: 'center',
      display: 'inline-block',
      whiteSpace: 'nowrap',
      overflow: 'visible',
    }}
  >
    UNREACHABLE
  </div>
);

UnreachableBadge.propTypes = {
  id: PropTypes.string,
};

UnreachableBadge.defaultProps = {
  id: undefined,
};

export default UnreachableBadge;
